import { Search } from "@mui/icons-material";
import { Button, Card, CardContent, CardHeader, IconButton, Menu, MenuItem, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { SearchIconWrapper, StyledInputBase, StyledTableCell } from "../../../common/style/styles";

// 아이콘콘
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useNavigate } from "react-router-dom";
import { initialAlert, useAlert } from "../../../provider/AlertContextProvider";
import { useProgress } from "../../../contexts/ProgressContextProvider";
import { useState,KeyboardEvent, useCallback, useEffect } from "react";
import { T_Page } from "../../../common/model/apiModel";
import { T_Place } from "../../../common/model/placeModel";
import apis from "../../../common/apis";
import { T_Product } from "../../../common/model/productModel";

export default function ProductList(){

    //use
    const navigator = useNavigate();
    const {alert,setAlert} = useAlert();
    const {showProgress,setShowProgress} = useProgress();
   
   // 리스트 관련
    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Product[] | null>(null);
    const [pageInfo,setPageInfo] = useState<T_Page>()
    // 페이지 변경 핸들러
    const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };


    // 행 단위 메뉴 상태
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuRow, setMenuRow] = useState<number | null>(null);
    const menuOpen = Boolean(anchorEl);
    const handleRowMenuClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
        setAnchorEl(e.currentTarget);
        setMenuRow(idx);
    };
    const handleRowMenuClose = () => {
        setAnchorEl(null);
        setMenuRow(null);
    };

    function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (e.key === 'Enter') {
            e.preventDefault(); // form 리프레시 방지
    //        getList()
        }
        }


    // 검색관련련
    const [skeyword,setSkeyword]=useState("");


       const getList = useCallback(async () => {
    try {
      setShowProgress(true);
      const result = await apis.product.productList(
        {
          page:Number(page),
          pagesize:pagesize,
        }
      );
        console.log("result:",result)
        if(result.code=="1"){
          
            setList(result.data.list);
            setShowProgress(false);

        }else{
             
          setShowProgress(false);
        }

   

    } catch (err: any) {
      setShowProgress(false);
    }
  }, [page]);

    const deleteData = async(idx:number)=>{
    setAlert({...alert,title:"확인",msg:"정말로 삭제 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                   const result = await apis.product.productDelete({idx:idx})
                   console.log("result:",result)
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"삭제가 완료되었습니다."})
                          getList();
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"삭제중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})

    }
  
    useEffect(() => {
      // getGroupList();
      
      const init = async () => {
        await getList();
      };
      init();
    }, [page]);


 return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        sx={{ pr: 5, pb: 0, mb: 0 }}
        title="제품 리스트"
        
        action={
          <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >

                  <Search>
                      <SearchIconWrapper onClick={() => setPage(1)}>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={skeyword}
                        onChange={(e) => {
                          setSkeyword(e.target.value);
                        }
                      }
                        onKeyDown={onKeyDown}
                      />
                    </Search>                  
       
         
          <Button variant="outlined" onClick={() => navigator('/product/insert') }>
            등록
          </Button>
          </Stack>
        }
      />
      <CardContent>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" sx={{ width: 180 }}>코드</StyledTableCell>
                <StyledTableCell align="left" sx={{ width: '20%' }}>제품명</StyledTableCell>
                <StyledTableCell align="left">타입</StyledTableCell>
                <StyledTableCell align="left">가격</StyledTableCell>
                <StyledTableCell align="left">내용</StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '10%' }}>비고</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list?.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell align="left">{item.code}</TableCell>
                  <TableCell align="left">{item.name}</TableCell>
                  <TableCell align="left">{item.type}</TableCell>
                  <TableCell align="left">{item.price}  / {item.price2}</TableCell>
                  <TableCell align="left">{item.content}</TableCell>
                  {/* 비고 셀(수정/삭제) */}
                  <TableCell align="center">
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleRowMenuClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === index}
                      onClose={handleRowMenuClose}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleRowMenuClose();
                          navigator('/product/edit', { state: { item } });
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async () => {
                          handleRowMenuClose();
                          // TODO: 삭제 로직
                         item.idx &&  deleteData(item.idx);
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ pt: 5 }}
        >
          <Pagination
            count={pageInfo?.pages || 1}
            showFirstButton
            showLastButton
            boundaryCount={2}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}